import { ActionsUnion } from '../types';
import { createAction } from '../../utils/action';
import ActionTypes from '../actionTypes';
import { RestErrorResponse } from '../../types/response/RestErrorResponse';
import { DeliveryZones, Transport } from './types';

export const Actions = {
  getMeansOfTransport: () => createAction(ActionTypes.GET_MEANS_OF_TRANSPORT),
  getMeansOfTransportSuccess: (data: Transport[]) => createAction(ActionTypes.GET_MEANS_OF_TRANSPORT_SUCCESS, data),
  getMeansOfTransportError: (error: RestErrorResponse) => createAction(ActionTypes.GET_MEANS_OF_TRANSPORT_ERROR, error),

  getDeliveryZones: () => createAction(ActionTypes.GET_DELIVERY_ZONES),
  getDeliveryZonesSuccess: (data: DeliveryZones) => createAction(ActionTypes.GET_DELIVERY_ZONES_SUCCESS, data),
  getDeliveryZonesError: (error: RestErrorResponse) => createAction(ActionTypes.GET_DELIVERY_ZONES_ERROR, error),

  manageDeliveryZone: () => createAction(ActionTypes.MANAGE_DELIVERY_ZONE),
  manageDeliveryZoneSuccess: () => createAction(ActionTypes.MANAGE_DELIVERY_ZONE_SUCCESS),
  manageDeliveryZoneError: (error: RestErrorResponse) => createAction(ActionTypes.MANAGE_DELIVERY_ZONE_ERROR, error)
};

export type ZonesActions = ActionsUnion<typeof Actions>;
